import { RoutalTooltip } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import BugReportIcon from '../../../assets/svg/left-bar/BugReportIcon';
import ChatIcon from '../../../assets/svg/left-bar/ChatIcon';
import { useAsUser } from '../../../hooks/session/useAsUser';
import { useRetrieveUser } from '../../../hooks/user/useRetrieveUser';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import Text from '../../../react-components/Text';
import { intercom } from '../../../services/intercom';
import Usersnap from '../../../services/usersnap';
import SideBarMenuItemContainer from './SideBarMenuItemContainer';

export const SideBarHelp = () => {
  const { data: user } = useRetrieveUser();
  const { asUser } = useAsUser();
  const { data: userCredentials } = useRetrieveUserCredentials();

  const helpActions = [
    ...(userCredentials?.isStaff(asUser)
      ? [
          // {
          //   id: `help.users`,
          //   label: <Text intlId="help.users" style={{ color: `white`, cursor: `pointer` }} />,
          //   icon: SupervisedUserCircle,
          //   onClick: () => {},
          // },
          {
            id: `help.bug`,
            label: <Text intlId="help.bug" style={{ color: `white`, cursor: `pointer` }} />,
            icon: BugReportIcon,
            onClick: () => {
              if (user) {
                Usersnap.open(user.id, user.email);
              }
            },
          },
        ]
      : []),
    {
      id: `help.chat`,
      label: <Text intlId="help.chat" style={{ color: `white`, cursor: `pointer` }} />,
      icon: ChatIcon,
      onClick: () => {
        intercom.open();
      },
    },
  ];

  return (
    <>
      {helpActions?.map((element) => (
        <SideBarHelpElement element={element} />
      ))}
    </>
  );
};

// I had to create a new component to add the hover interaction
interface SideBarHelpElementProps {
  element: {
    id: string;
    label: React.ReactElement;
    icon: React.ElementType;
    onClick: () => void;
  };
}

const SideBarHelpElement = ({ element }: SideBarHelpElementProps) => {
  const [isHover, setHover] = useState<boolean>(false);
  return (
    <RoutalTooltip id={element.id || ``} title={element.label || ``} placement="right">
      <SideBarMenuItemContainer
        onClick={element.onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <element.icon isHover={isHover} />
      </SideBarMenuItemContainer>
    </RoutalTooltip>
  );
};
